import { Injectable } from '@angular/core';

/**
 * View state of the conversation list that must outlive the component —
 * SPEC-2026-09-internal-chat-pwa (T-24).
 *
 * The list is unmounted every time a conversation opens in the compact popup, and
 * on a phone every time the route leaves the list. Which sections the user collapsed
 * and whether the unread filter is on are choices, not transient rendering, so they
 * live here for the lifetime of the application. A reload starts over, as before.
 */
@Injectable({ providedIn: 'root' })
export class ChatConversationListStateService {

  /**
   * Keys of the sections the user COLLAPSED — the inverse of a map of expanded ones,
   * deliberately: section keys are dynamic (a custom section appears the moment it is
   * created), and an unknown key has to default to expanded.
   */
  readonly collapsedSections = new Set<string>();

  /** "Não lidas" quick filter — composes with the search term. */
  unreadOnly = false;

  /** Conversation-list search term. Empty means "not searching". */
  searchTerm = '';
}
